import React from "react";
import ReactECharts from "echarts-for-react";
import "./DonutProgressChart.scss";

const DonutProgressChart = ({
  data = [],
  colors = [],
  centerLabel = "Progress",
  percentagePrecision = 0,
  percentage,
  width = 135,
  height = 135,
  showCenterLabel = true,
  progressIndex = 0,
}) => {
  // Helper: parse values like "10%", "5L", "2Cr" into numeric values
  const parseValue = (val) => {
    if (typeof val === "number") return val;
    if (typeof val === "string") {
      const num = parseFloat(val.replace(/[^\d.]/g, ""));
      if (val.includes("%")) return num;
      if (/L$/i.test(val)) return num * 100000;
      if (/Cr$/i.test(val)) return num * 10000000;
      return num;
    }
    return 0;
  };

  // Enriched data with parsedValue
  const parsedData = data.map((item) => ({
    ...item,
    parsedValue: parseValue(item.value),
  }));

  const total = parsedData.reduce((sum, item) => sum + item.parsedValue, 0);
  const progressValue = parsedData[progressIndex]?.parsedValue || 0;

  // Use passed percentage if provided, else calculate
  const computedPercentage =
    percentage !== undefined
      ? Number(percentage).toFixed(percentagePrecision)
      : total === 0
      ? 0
      : ((progressValue / total) * 100).toFixed(percentagePrecision);

  const graphic = showCenterLabel
    ? [
        {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: `${computedPercentage}%`,
            fill: "#212330",
            fontSize: 22,
            fontFamily: "Gilroy, sans-serif",
            fontWeight: 600,
            textAlign: "center",
          },
        },
        {
          type: "text",
          left: "center",
          top: "56%",
          style: {
            text: centerLabel,
            fill: "#76798D",
            fontSize: 11,
            fontFamily: "Gilroy, sans-serif",
            fontWeight: 500,
            textAlign: "center",
          },
        },
      ]
    : [];

  const option = {
    tooltip: {
      trigger: "item",
      formatter: ({ name, dataIndex, color }) => {
        const originalValue = data?.[dataIndex]?.value ?? "-";
        return `
          <div style="display:flex; flex-direction:column; gap:4px;">
            <div style="display:flex; align-items:center; gap:6px;">
              <span style="width:13px; height:13px; background:${color}; border-radius:2px; display:inline-block;"></span>
              <span style="font-weight:600;">${name}</span>
              <div style="color:#76798d;">${originalValue}</div>
            </div>
          </div>
        `;
      },
    },
    color: colors,
    series: [
      {
        type: "pie",
        radius: ["70%", "100%"],
        label: { show: false },
        labelLine: { show: false },
        data: parsedData.map(({ name, parsedValue }) => ({
          name,
          value: parsedValue,
        })),
      },
    ],
    graphic,
  };

  return (
    <div
      className="donut-progress-chart"
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <ReactECharts option={option} style={{ width, height }} />
    </div>
  );
};

export default DonutProgressChart;
